import { Component, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';

import { ContactsCustomListItem } from './types';

@Component({
  selector: 'app-contacts-directory',
  templateUrl: './contacts-directory.component.html',
  styleUrls: ['./contacts-directory.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsDirectoryComponent {
  private readonly cdr = inject(ChangeDetectorRef);

  selectedDirectory?: ContactsCustomListItem;

  changeSelectedDirectory(directory?: ContactsCustomListItem) {
    this.selectedDirectory = directory;
    this.cdr.markForCheck();
  }
}
